import { render, staticRenderFns } from "./DeviceOTAList.vue?vue&type=template&id=0c6ad426&scoped=true"
import script from "./DeviceOTAList.vue?vue&type=script&lang=ts"
export * from "./DeviceOTAList.vue?vue&type=script&lang=ts"
import style0 from "./DeviceOTAList.vue?vue&type=style&index=0&id=0c6ad426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ad426",
  null
  
)

export default component.exports